import useSWR from 'swr';
import { createFetcher } from './Requests';
import { Ledger, ErrorRes } from '../types';

// eslint-disable-next-line import/prefer-default-export
export const fetchLedgerDetails = (userId: string, shouldFetch = true) => {
  const { url, fetcher } = createFetcher(`/ledgers/${userId}`);
  return { swr: useSWR<Ledger, ErrorRes>(shouldFetch ? url : null, fetcher), url };
};
